import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import {
	MISSION_TYPE_REUNION_TYPE,
	THEME_COLOR_BLUE,
	THEME_COLOR_MAIN
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Mission } from 'src/app/shared/models/mission/mission';
import { Solution } from 'src/app/shared/models/solution';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { graphic, format, EChartsOption } from 'echarts';
import { ConvertObjectToCalendarEvent } from 'src/app/shared/utils/convert-object-to-calendar-event';
import { State } from 'src/app/shared/enums/state.enum';
import { CalendarEvent } from 'angular-calendar';
import { StringUtils } from 'src/app/shared/utils/string-utils';
import { Planning } from 'src/app/shared/models/planning';
import { Route } from 'src/app/shared/models/route';

@Component({
	selector: 'app-list-planning',
	templateUrl: './list-planning.component.html',
	styleUrls: ['./list-planning.component.scss']
})
export class ListPlanningComponent implements OnInit, OnChanges {
	ZOOM_START_DAY = 31;
	ZOOM_END_DAY = 78;
	ZOOM_START_WEEK = 0;
	ZOOM_END_WEEK = 100;

	@Input() solution: Solution;
	@Input() events: CalendarEvent[];
	@Output() listViewEvent = new EventEmitter();

	option: EChartsOption;

	data: any;

	setBeneficiaire = {};
	maxStartSchedule;
	maxEndSchedule;

	daysFr = [
		'Dimanche',
		'Lundi',
		'Mardi',
		'Mercredi',
		'Jeudi',
		'Vendredi',
		'Samedi'
	];

	monthsFr = [
		'janv',
		'févr',
		'mars',
		'avr',
		'mai',
		'juin',
		'juill',
		'aout',
		'sept',
		'oct',
		'nov',
		'déc'
	];

	dateOfStart: Date = null;
	dateOfEnd: Date = null;

	unassignedMissionsArr;

	isViewByDay = false;
	isViewByIntervenant = false;
	searchedText: string = ''; // pour que les users puissent filtrer par employé/bénéficiaire en vue listing semaine
	eventToSend: CalendarEvent<any>;
	filteredRoutesByDayOrWeek: Route[];

	stringUtils = new StringUtils();

	constructor(
		private facade: FacadeService,
		private dateUtils: DateUtils,
		private calendarConvert: ConvertObjectToCalendarEvent
	) {}

	ngOnInit(): void {
		this.maxStartSchedule =
			(this.facade.dataStorageService.getParamMaxDay() * 100) / 24;
		this.maxEndSchedule =
			(this.facade.dataStorageService.getParamMinDay() * 100) / 24;
		this.initData();
		this.eventToSend = null;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.solution) {
			if (changes.solution.currentValue !== changes.solution.previousValue) {
				this.dateOfStart = null;
				this.dateOfEnd = null;
			}
		}

		this.initData();
	}

	/**
	 * @description insère une mission dans la structure de données missions à afficher sur le planning vue liste
	 * @param mission mission à insérer
	 * @param beneficiaireName nom du bénéficiare
	 * @param specName spécialité de la mission
	 * @param indexOfElement index du bénéficiaire ou employé lié à la mission
	 * @param idEmployeeOfBenef id employé ou bénéficiaire
	 */
	pushMissionIntoData(
		mission: Mission,
		beneficiaireName: string,
		indexOfElement: number,
		idEmployeeOfBenef: number
	) {
		if (mission.realStart) {
			this.data.structMission.data.push([
				indexOfElement,
				this.dateUtils.getFullDateFromDateAndMinutes(
					new Date(mission.missionRequest.date),
					mission.realStart
				),
				this.dateUtils.getFullDateFromDateAndMinutes(
					new Date(mission.missionRequest.date),
					mission.realEnd
				),
				mission.id,
				beneficiaireName,
				mission.missionRequest.beneficiaire?.id,
				State[mission.state].includes(State.CANCELED) ? 1 : 0,
				idEmployeeOfBenef
			]);
		} else {
			this.data.structMission.data.push([
				indexOfElement,
				this.dateUtils.getFullDateFromDateAndMinutes(
					new Date(mission.missionRequest.date),
					mission.plannedStart
				),
				this.dateUtils.getFullDateFromDateAndMinutes(
					new Date(mission.missionRequest.date),
					mission.plannedEnd
				),
				mission.id,
				beneficiaireName,
				mission.missionRequest.beneficiaire?.id,
				State[mission.state].includes(State.CANCELED) ? 1 : 0,
				idEmployeeOfBenef
			]);
		}
	}

	/**
	 * @description insère une mission dans la structure de données missions à afficher sur le planning vue liste
	 * @param mission mission à insérer
	 * @param indexOfElement index du bénéficiaire ou employé lié à la mission
	 * @param idEmployeeOfBenef id employé ou bénéficiaire
	 */
	displaySearchedMissions(
		mission: Mission,
		indexOfElement: number,
		idEmployeeOfBenef: number
	) {
		this.searchedText =
			this.stringUtils.normalizeStringInLowercaseWithoutAccent(
				this.searchedText
			);

		const identity =
			this.stringUtils.normalizeStringInLowercaseWithoutAccent(
				mission.missionRequest.beneficiaire.firstName
			) +
			' ' +
			this.stringUtils.normalizeStringInLowercaseWithoutAccent(
				mission.missionRequest.beneficiaire.lastName
			);

		if (identity.includes(this.searchedText)) {
			if (!this.dateOfStart) {
				this.dateOfStart = this.dateUtils.getMonday(
					mission.missionRequest.date
				);
				this.dateOfEnd = new Date(this.dateOfStart);
				this.dateOfEnd.setDate(
					this.dateOfEnd.getDate() + (this.isViewByDay ? 1 : 5)
				);
			}
		} else {
			if (
				mission.missionRequest.beneficiaire.firstName
					.toLowerCase()
					.includes(this.searchedText) ||
				mission.missionRequest.beneficiaire.lastName
					.toLowerCase()
					.includes(this.searchedText)
			) {
				if (!this.dateOfStart) {
					this.dateOfStart = this.dateUtils.getMonday(
						mission.missionRequest.date
					);
					this.dateOfEnd = new Date(this.dateOfStart);
					this.dateOfEnd.setDate(
						this.dateOfEnd.getDate() + (this.isViewByDay ? 1 : 5)
					);
				}

				this.pushMissionIntoData(
					mission,
					mission.missionRequest.beneficiaire.firstName +
						' ' +
						mission.missionRequest.beneficiaire.lastName,
					indexOfElement,
					idEmployeeOfBenef
				);
			}
		}
	}

	initData() {
		this.data = {
			//Structure qui peut contenir employé & ou bénéficiaire
			structLabelEmploye: {
				dimensions: ['name', 'id', 'idx'],
				data: []
			},
			structMission: {
				dimensions: [
					{ name: 'struct label employe index', type: 'number' },
					{ name: 'start', type: 'time' },
					{ name: 'end', type: 'time' },
					{ name: 'id', type: 'number' },
					{ name: 'beneficiaire', type: 'string' },
					{ name: 'beneficiaireId', type: 'number' },
					{ name: 'canceled', type: 'number' },
					{ name: 'employeeId', type: 'number' }
				],
				data: []
			}
		};
		if (this.solution) {
			//Position d'un employé ou d'un bénéficiaire dans la structure de données
			let indexOfElement = null;
			// Pour les missions non-affectées
			if (this.solution.unassignedMissions) {
				// Si la vue jour est activée, on filtre les missions pour le jour selectionné
				if (this.isViewByDay) {
					this.unassignedMissionsArr = this.solution.unassignedMissions.filter(
						(mission) => {
							if (!this.dateOfStart) {
								return (
									new Date(mission.missionRequest.date).getTime() ===
									this.dateUtils
										.getMonday(mission.missionRequest.date)
										.getTime()
								);
							} else if (this.dateOfStart) {
								return (
									new Date(mission.missionRequest.date).getTime() ===
									this.dateOfStart.getTime()
								);
							}
						}
					);
				} else {
					this.unassignedMissionsArr = this.solution.unassignedMissions;
				}

				this.unassignedMissionsArr = this.unassignedMissionsArr.filter(
					(mission: Mission) => {
						return (
							mission.missionRequest.missionType.type !==
							MISSION_TYPE_REUNION_TYPE
						);
					}
				);
				this.unassignedMissionsArr.forEach((mission, idx) => {
					const specName = mission?.missionRequest?.careSpecialty
						? mission?.missionRequest?.careSpecialty.name
						: '';
					const hasBeneficiaire = mission.missionRequest.beneficiaire
						? true
						: false;
					const beneficiaireName = hasBeneficiaire
						? mission.missionRequest.beneficiaire.firstName +
						  ' ' +
						  mission.missionRequest.beneficiaire.lastName
						: 'Sans bénéficiaire';

					if (hasBeneficiaire) {
						indexOfElement = this.data.structLabelEmploye.data.findIndex(
							(e) => {
								return (
									e[1] === mission.missionRequest.beneficiaire.id && e[2] < 0
								);
							}
						);
					} else {
						indexOfElement = 1000;
					}

					// Si le bénéficiaire est déjà présent dans la liste (on évite les doublons dans la structure de données)
					if (
						this.data.structLabelEmploye.data.find((benef) => {
							if (mission.missionRequest.beneficiaire) {
								return (
									benef[1] === mission.missionRequest.beneficiaire.id &&
									benef[2]
								);
							}
						}) &&
						hasBeneficiaire
					) {
						this.treatSearchedText(
							mission,
							beneficiaireName,
							indexOfElement,
							idx
						);
					} else if (hasBeneficiaire) {
						// Bénéficiaire inséré dans la structure de données
						this.data.structLabelEmploye.data.push([
							'(B):' +
								mission.missionRequest.beneficiaire.firstName +
								' ' +
								mission.missionRequest.beneficiaire.lastName,
							mission.missionRequest.beneficiaire.id,
							-idx - 1
						]);

						indexOfElement = this.data.structLabelEmploye.data.findIndex(
							(e) => {
								return (
									e[1] === mission.missionRequest.beneficiaire.id && e[2] < 0
								);
							}
						);
						this.treatSearchedText(
							mission,
							beneficiaireName,
							indexOfElement,
							idx
						);
					} else {
						// Bénéficiaire inséré dans la structure de données
						this.data.structLabelEmploye.data.push([
							'Sans bénéficiaire',
							1000,
							-idx - 1
						]);

						indexOfElement = 0;
						if (mission.missionRequest) {
							this.treatSearchedText(
								mission,
								beneficiaireName,
								indexOfElement,
								idx
							);
						}
					}
				});
			}
			// Pour les missions affectées
			if (this.solution.plannings) {
				this.solution.plannings.forEach((planning) => {
					if (planning.routes && planning.employee) {
						planning.routes.forEach((route) => {
							route.employee = planning.employee;
						});
						// Tri des employées ayant des missions au jour selectionné par jour et par type de mission
						if (this.isViewByDay) {
							this.filteredRoutesByDayOrWeek = planning.routes.filter(
								(route) => {
									const isMissionNotParentOfGroupAndNotReunion = (
										mission: Mission
									) =>
										!(
											!mission.missionParent &&
											mission.missionRequest.nombreIntervenant > 1
										) &&
										mission.missionRequest?.missionType.type !==
											MISSION_TYPE_REUNION_TYPE;

									const containOnlyReunionOrMissionParentOfGroup =
										route.missions.filter(
											isMissionNotParentOfGroupAndNotReunion
										).length === 0;
									if (
										route.missions.length > 0 &&
										!containOnlyReunionOrMissionParentOfGroup
									) {
										if (!this.dateOfStart) {
											return (
												new Date(route.date).getTime() ===
												this.dateUtils.getMonday(route.date).getTime()
											);
										} else if (this.dateOfStart) {
											return (
												new Date(route.date).getTime() ===
												this.dateOfStart.getTime()
											);
										}
									}
								}
							);
							this.filteredRoutesByDayOrWeek.forEach((route) => {
								this.data.structLabelEmploye.data.push([
									route.employee.firstName + ' ' + route.employee.lastName,
									route.employee.id,
									route.employee.id
								]);
							});
						} else {
							this.filteredRoutesByDayOrWeek = planning.routes;

							this.filteredRoutesByDayOrWeek.forEach((route) => {
								// Eviter les doublons d'employee dans la liste et ceux qui n'ont pas de missions
								const isMissionNotParentOfGroupAndNotReunion = (
									mission: Mission
								) =>
									!(
										!mission.missionParent &&
										mission.missionRequest.nombreIntervenant > 1
									) &&
									mission.missionRequest?.missionType.type !==
										MISSION_TYPE_REUNION_TYPE;

								const containOnlyReunionOrMissionParentOfGroup =
									route.missions.filter(isMissionNotParentOfGroupAndNotReunion)
										.length === 0;
								if (
									!this.data.structLabelEmploye.data.find((employe) => {
										return employe[1] === planning.employee.id;
									}) &&
									route.missions.length > 0 &&
									!containOnlyReunionOrMissionParentOfGroup
								) {
									this.data.structLabelEmploye.data.push([
										route.employee.firstName + ' ' + route.employee.lastName,
										route.employee.id,
										route.employee.id
									]);
								}
							});
						}

						this.filteredRoutesByDayOrWeek
							.filter((route) => route.missions.length > 0)
							.flatMap((route) => {
								return route.missions;
							})
							.sort((a, b) => {
								if (a.realStart || b.realStart) {
									return (
										this.dateUtils
											.getFullDateFromDateAndMinutes(
												new Date(a.missionRequest.date),
												a.realStart
											)
											.getTime() -
										this.dateUtils
											.getFullDateFromDateAndMinutes(
												new Date(b.missionRequest.date),
												b.realStart
											)
											.getTime()
									);
								} else {
									return (
										this.dateUtils
											.getFullDateFromDateAndMinutes(
												new Date(a.missionRequest.date),
												a.plannedStart
											)
											.getTime() -
										this.dateUtils
											.getFullDateFromDateAndMinutes(
												new Date(b.missionRequest.date),
												b.plannedStart
											)
											.getTime()
									);
								}
							})
							.forEach((mission) => {
								// Missions avec type réunion ne sont pas affichées
								// Idem pour missionParent d'une mission groupée
								const isReunion =
									mission.missionRequest.missionType.type ===
									MISSION_TYPE_REUNION_TYPE;
								const isMissionParentOfGroup =
									!mission.missionParent &&
									mission.missionRequest.nombreIntervenant > 1;
								if (
									mission.missionRequest &&
									!isReunion &&
									!isMissionParentOfGroup
								) {
									indexOfElement = this.data.structLabelEmploye.data.findIndex(
										(e) => e[1] === planning.employee.id && e[2] > 0
									);
									const specName = mission?.missionRequest?.careSpecialty
										? mission?.missionRequest?.careSpecialty.name
										: '';
									const hasBeneficiaire = mission.missionRequest.beneficiaire
										? true
										: false;
									const beneficiaireName = hasBeneficiaire
										? mission.missionRequest.beneficiaire.firstName +
										  ' ' +
										  mission.missionRequest.beneficiaire.lastName
										: 'Pas de bénéficiaire';
									if (this.searchedText) {
										this.displaySearchedMissions(
											mission,
											indexOfElement,
											planning.employee.id
										);
										this.setBeneficiaire[mission.id] = {
											beneficiaireName,
											specName
										};
									} else {
										if (!this.dateOfStart) {
											this.dateOfStart = this.dateUtils.getMonday(
												mission.missionRequest.date
											);
											this.dateOfEnd = new Date(this.dateOfStart);
											this.dateOfEnd.setDate(
												this.dateOfEnd.getDate() + (this.isViewByDay ? 1 : 5)
											);
										}
										this.pushMissionIntoData(
											mission,
											beneficiaireName,
											indexOfElement,
											planning.employee.id
										);
										this.setBeneficiaire[mission.id] = {
											beneficiaireName,
											specName
										};
									}
								}
							});
					}
				});
			}
		}
		this.option = this.makeOption();
	}

	treatSearchedText(
		mission: Mission,
		beneficiaireName: string,
		indexOfElement: number,
		idx: number
	) {
		//Barre de recherche
		if (this.searchedText) {
			this.displaySearchedMissions(mission, indexOfElement, -idx - 1);

			const specName = mission?.missionRequest?.careSpecialty
				? mission?.missionRequest?.careSpecialty.name
				: '';

			this.setBeneficiaire[mission.id] = {
				beneficiaireName,
				specName
			};
		} else {
			if (!this.dateOfStart) {
				this.dateOfStart = this.dateUtils.getMonday(
					mission.missionRequest.date
				);
				this.dateOfEnd = new Date(this.dateOfStart);
				this.dateOfEnd.setDate(
					this.dateOfEnd.getDate() + (this.isViewByDay ? 1 : 5)
				);
			}
			this.pushMissionIntoData(
				mission,
				beneficiaireName,
				indexOfElement,
				-idx - 1
			);

			const specName = mission?.missionRequest?.careSpecialty
				? mission?.missionRequest?.careSpecialty.name
				: '';

			this.setBeneficiaire[mission.id] = {
				beneficiaireName,
				specName
			};
		}
	}

	makeOption(): any {
		let HEIGHT_RATIO = 0.9;
		let DIM_CATEGORY_INDEX = 0;
		let DIM_TIME_ARRIVAL = 1;
		let DIM_TIME_DEPARTURE = 2;
		let _rawData;
		let self = this;

		_rawData = this.data;
		function renderGanttItem(params, api) {
			let categoryIndex = api.value(DIM_CATEGORY_INDEX);
			let timeArrival = api.coord([api.value(DIM_TIME_ARRIVAL), categoryIndex]);
			let timeDeparture = api.coord([
				api.value(DIM_TIME_DEPARTURE),
				categoryIndex
			]);
			let barLength = timeDeparture[0] - timeArrival[0];
			// Get the heigth corresponds to length 1 on y axis.
			let barHeight = api.size([0, 1])[1] * HEIGHT_RATIO;
			let x = timeArrival[0];
			let y = timeArrival[1] - barHeight / 2;
			// let benefName = _rawData.structMission.data.find(e=>e[3]===api.value(3))[4];
			let benefName = self.setBeneficiaire[api.value(3)].beneficiaireName;
			let specName = self.setBeneficiaire[api.value(3)].specName;
			let benefDecription = self.setBeneficiaire[api.value(3)].beneficiaireName;
			let benefNameWidth = format.getTextRect(benefName).width;
			let benefHeight = format.getTextRect(benefDecription).height;
			let text;
			let speArr = specName.split(' ');

			let employee = self.getEmpFromId(api.value(7));

			if (barLength > benefNameWidth + 20 && x + barLength >= 180) {
				if (barHeight > benefHeight) {
					text = benefName + '\n \n - \n \n';
					for (const element of speArr) {
						if (barLength > format.getTextRect(element).width + 20) {
							text += element + '\n \n';
						} else {
							text = benefName;
							break;
						}
					}
				} else {
					text = benefName;
				}
			} else {
				benefName =
					benefName.split(' ')[0].charAt(0).toUpperCase() +
					'.' +
					benefName.split(' ')[1];
				benefNameWidth = format.getTextRect(benefName).width;
				if (barLength > benefNameWidth + 20 && x + barLength >= 180) {
					text = benefName + '\n \n - \n \n';
					if (barHeight > benefHeight) {
						for (const element of speArr) {
							if (barLength > format.getTextRect(element).width + 20) {
								text += element + '\n \n';
							} else {
								text = benefName;
								break;
							}
						}
					}
				} else {
					benefName = benefName.split('.')[1];
					benefNameWidth = format.getTextRect(benefName).width;
					benefDecription =
						self.setBeneficiaire[api.value(3)].beneficiaireName.split(' ')[1];
					benefHeight = format.getTextRect(benefDecription).height;
					text = benefName + '\n \n - \n \n';
					if (barLength > benefNameWidth + 20 && x + barLength >= 180) {
						if (barHeight > benefHeight) {
							for (const element of speArr) {
								if (barLength > format.getTextRect(element).width + 20) {
									text += element + '\n \n';
								} else {
									text = benefName;
									break;
								}
							}
						} else {
							text = benefName;
						}
					} else {
						text = '';
					}
				}
			}

			let rectNormal = clipRectByRect(params, {
				x: x,
				y: y,
				width: barLength,
				height: barHeight
			});
			let rectText = clipRectByRect(params, {
				x: x,
				y: y,
				width: barLength,
				height: barHeight
			});
			return {
				type: 'group',
				children: [
					{
						type: 'rect',
						ignore: !rectNormal,
						shape: rectNormal,
						style: {
							stroke: '#000',
							fill:
								api.value(6) === 1 // canceled ?
									? self.calendarConvert.colorTransparent.secondary
									: api.value(7) > 0
									? self.calendarConvert.getColorFromEmployee(employee)
											?.secondary
									: '#FFF'
						}
					},
					{
						type: 'rect',
						ignore: !rectText,
						shape: rectText,
						style: {
							fill: 'transparent',
							stroke: 'transparent',
							text: text,
							textFill: '#000',
							fontWeight: 'bold',
							fontFamily: '"Comfortaa", cursive',
							fontSize: '0.7em'
						}
					}
				]
			};
		}

		function clipRectByRect(params, rect) {
			return graphic.clipRectByRect(rect, {
				x: params.coordSys.x,
				y: params.coordSys.y,
				width: params.coordSys.width,
				height: params.coordSys.height
			});
		}

		return {
			tooltip: {
				trigger: 'item',
				formatter: function (params) {
					if (params.encode.x) {
						//Elements dans la liste
						let start = new Date(params.value[params.encode.x[0]]);
						let end = new Date(params.value[params.encode.x[1]]);
						return (
							'<strong>Beneficiaire</strong> : ' +
							params.value[params.encode.x[2]] +
							'<br>' +
							'<strong>Date</strong> : ' +
							start.toLocaleDateString('fr-FR') +
							'<br>' +
							'<strong>Début </strong>: ' +
							start.toLocaleTimeString('fr-FR') +
							'<br>' +
							'<strong>Fin </strong>: ' +
							end.toLocaleTimeString('fr-FR')
						);
					} else {
						//Intitulé
						return '' + params.value[params.encode.y[0] + 1];
					}
				}
			},
			animation: false,
			// toolbox: {
			// 	left: 20,
			// 	top: 0,
			// 	itemSize: 20
			// },
			// title: {
			// 	text: 'Gantt of Airport structMission',
			// 	left: 'center'
			// },
			dataZoom: [
				{
					type: 'slider',
					xAxisIndex: 0,
					filterMode: 'weakFilter',
					height: 20,
					bottom: 0,
					start: self.isViewByDay
						? self.maxStartSchedule
						: self.ZOOM_START_WEEK,
					end: self.isViewByDay ? self.maxEndSchedule : self.ZOOM_END_WEEK,
					handleIcon:
						'path://M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
					handleSize: '80%',
					showDetail: false,
					zoomLock: false,
					backgroundColor: THEME_COLOR_MAIN,
					moveHandleStyle: {
						color: THEME_COLOR_BLUE
					},
					fillerColor: THEME_COLOR_BLUE,
					handleStyle: {
						color: THEME_COLOR_BLUE
					}
				},
				{
					type: 'inside',
					id: 'insideX',
					xAxisIndex: 0,
					filterMode: 'weakFilter',
					start: 0,
					end: 26,
					zoomOnMouseWheel: false,
					moveOnMouseMove: true
				},
				{
					type: 'slider',
					yAxisIndex: 0,
					zoomLock: true,
					width: 10,
					right: 10,
					top: 70,
					bottom: 20,
					start:
						_rawData.structLabelEmploye.data.length > 10
							? _rawData.structLabelEmploye.data.length > 20
								? 70
								: 72
							: 0,
					end: 100,
					handleSize: 0,
					showDetail: false,
					backgroundColor: THEME_COLOR_BLUE,
					moveHandleStyle: {
						color: THEME_COLOR_BLUE
					},
					fillerColor: THEME_COLOR_BLUE,
					handleStyle: {
						color: THEME_COLOR_BLUE
					}
				},
				{
					type: 'inside',
					id: 'insideY',
					yAxisIndex: 0,
					start: 95,
					end: 100,
					zoomOnMouseWheel: false,
					moveOnMouseMove: true,
					moveOnMouseWheel: true
				}
			],
			grid: {
				show: true,
				top: 70,
				bottom: 20,
				left: 150,
				right: 20,
				backgroundColor: '#fff',
				borderWidth: 0
			},
			xAxis: {
				type: 'time',
				position: 'top',
				splitLine: {
					show: true,
					lineStyle: {
						color: '#929ABA',
						type: 5
					}
				},
				axisLine: {
					show: true
				},
				axisTick: {
					show: true,
					lineStyle: {
						color: '#929ABA'
					}
				},
				axisLabel: {
					color: '#929ABA',
					inside: false
				},

				min: this.dateOfStart,
				max: this.dateOfEnd
			},
			yAxis: {
				axisTick: {
					show: true,
					length: 100,
					lineStyle: {
						color: '#929ABA'
					}
				},
				splitLine: {
					show: true,
					lineStyle: {
						type: 5,
						color: '#929ABA'
					}
				},
				axisLine: { show: true },
				axisLabel: {
					show: true,
					fontFamily: '"Comfortaa", cursive',
					fontWeight: 'bold',
					fontSize: '0.8em',
					color: '#262c5e',
					align: 'right',
					formatter: function (value) {
						return value.split(' ').join('\n \n');
					}
				},

				min: 0,
				max: _rawData.structLabelEmploye.data.length - 1,
				data: _rawData.structLabelEmploye.data.map(function (item) {
					return item[0].split(' ')[0] + ' ' + item[0].split(' ')[1];
				})
			},
			series: [
				{
					id: 'missionData',
					type: 'custom',
					renderItem: renderGanttItem,
					dimensions: _rawData.structMission.dimensions,
					encode: {
						x: [DIM_TIME_ARRIVAL, DIM_TIME_DEPARTURE, 4],
						y: DIM_CATEGORY_INDEX,
						tooltip: [
							DIM_CATEGORY_INDEX,
							DIM_TIME_ARRIVAL,
							DIM_TIME_DEPARTURE,
							4
						]
					},
					data: _rawData.structMission.data
				}
			]
		};
	}

	previousClick() {
		if (this.dateOfStart.getDay() > 1) {
			this.dateOfStart.setDate(this.dateOfStart.getDate() - 1);
			this.dateOfEnd = new Date(this.dateOfStart);
			this.dateOfEnd.setDate(this.dateOfStart.getDate() + 1);
		}
		this.initData();
		this.option = this.makeOption();
	}

	nextClick() {
		if (this.dateOfStart.getDay() < 5) {
			this.dateOfStart.setDate(this.dateOfStart.getDate() + 1);
			this.dateOfEnd = new Date(this.dateOfStart);
			this.dateOfEnd.setDate(this.dateOfStart.getDate() + 1);
		}
		this.initData();
		this.option = this.makeOption();
	}

	resetClick() {
		this.dateOfStart = this.dateUtils.getMonday(this.dateOfStart);
		this.dateOfEnd = new Date(this.dateOfStart);
		this.dateOfEnd.setDate(
			this.dateOfStart.getDate() + (this.isViewByDay ? 1 : 5)
		);
		this.option = this.makeOption();
	}

	changeDayType(isDay) {
		this.isViewByDay = isDay;
		//  this.resetClick();
		if (this.isViewByDay) {
			// On update la date de force
			this.dateOfStart = this.dateUtils.getMonday(this.dateOfStart);
			this.dateOfEnd = new Date(this.dateOfStart);
			this.dateOfEnd.setDate(
				this.dateOfStart.getDate() + (this.isViewByDay ? 1 : 5)
			);
			// Init des données + options
			this.initData();
			this.option = this.makeOption();
		}
	}

	changeListingType(isViewByIntervenant) {
		this.isViewByIntervenant = isViewByIntervenant;
	}

	/**
	 * Catches mission clicked
	 * @param event mission clicked
	 * @param type type of event
	 */
	onChartEvent(event) {
		this.eventToSend = this.events.find((ev) => {
			if (ev.meta.mission?.id) {
				return ev.meta.mission?.id === event.value[3];
			} else if (ev.meta.route) {
				return ev.meta.route.missions.find((mission) => {
					return mission.missionRequest.id === event.value[3];
				});
			}
		});
		this.openEventModal(event.value[3]);
	}

	openEventModal(missionId: number) {
		this.sendListViewEvent(missionId);
	}

	/**
	 * send event to parent planning
	 * @param idMission missionId clicked
	 */
	sendListViewEvent(idMission?: number) {
		let sendedEventWithId = { event: this.eventToSend, id: idMission };
		this.listViewEvent.emit(sendedEventWithId);
	}

	getEmpFromId(empId: number) {
		const empToReturn = this.solution.plannings
			.filter((planning) => planning.employee.id === empId)
			.map((planning) => planning.employee)
			.pop();
		return empToReturn;
	}
}
